import React from 'react';
import {withNavigationWatcher} from '../../../contexts/navigation';
import {Redirect} from 'react-router-dom';
import {
    integrationPage,
    overviewPage,
}
from '../../../pages/dashboard/index';

const Home = () =>{
    return(<Redirect to="/dashboard/overview"/>);
}

const dashboardRoutes = [
    {
        path: '/',
        component: ()=>(<Redirect to="dashboard/overview"/>)
    },
    {
        path: '/dashboard',
        component: Home
    },
    {
        path: '/dashboard/overview',
        component: overviewPage
    },
    {
        path: '/dashboard/integrations',
        component: integrationPage
    },
]

export default dashboardRoutes.map(route => {
    return {
        ...route,
        component: withNavigationWatcher(route.component)
    };
});
